module.exports = text => text.trim().toLowerCase().replace(/[^a-z0-9 ]/g, '').replace(/ /g, '-')
